import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import {
  LOGIN_REQUIRED_MESSAGE,
  useLoginRequiredPopupApi,
} from '../../components/popups/LoginRequiredPopupHost';

export { LOGIN_REQUIRED_MESSAGE };

/** 로그인 필요 alert (확인 1버튼) */
export function useLoginRequiredPopup() {
  const location = useLocation();
  const { openAlert } = useLoginRequiredPopupApi();

  return useCallback(
    (options = {}) => {
      const returnTo =
        options.returnTo ?? `${location.pathname}${location.search}${location.hash}`;
      openAlert({ ...options, returnTo });
    },
    [location.pathname, location.search, location.hash, openAlert],
  );
}
